<div class="dialog-container" id="notification-details-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ 'notifications.details.title' | transloco }}</h2>
    <button mat-icon-button [attr.aria-label]="'common.close' | transloco" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <pre>{{ data.details }}</pre>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">
      {{ 'common.close' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
